import {
  CellRenderProps,
  defaultCellComponents,
} from "@sinecycle/growcomponents";
import { Popover } from "antd";
import { cloneElement } from "react";
import styled from "styled-components";

const StyledExtraInfo = styled("span")<{ has_info?: boolean }>`
  ${({ has_info }) => has_info && `border-bottom:1px dashed #737373`}
`;

interface ExtraInfoProps<T> extends CellRenderProps<T> {
  infoType: "DATE" | "TEXT";
  extraComponent: React.ReactElement;
  value: {
    has_info: boolean;
    value: any;
  };
}
function ExtraInfo<T>(props: ExtraInfoProps<T>) {
  function getComponent() {
    switch (props.infoType) {
      case "DATE":
        return defaultCellComponents.dateCell({
          ...props,
          value: props.value.value,
        });
      case "TEXT":
        return defaultCellComponents.textCell({
          ...props,
          value: props.value.value,
        });
      default:
        return defaultCellComponents.textCell({
          ...props,
          value: props.value.value,
        });
    }
  }
  const component = getComponent();

  const ExtraComponent = cloneElement(props.extraComponent, {
    ...props,
    value: props.value.value,
  });

  return (
    <Popover
      placement="right"
      content={props.value.has_info ? ExtraComponent : undefined}
    >
      <StyledExtraInfo has_info={props.value.has_info}>
        {component}
      </StyledExtraInfo>
    </Popover>
  );
}

export { ExtraInfo };
